import { HeartFilledIcon, HeartIcon } from '@iheartjane/reefer';

import { ImageActionButton } from '../imageActionButton/imageActionButton';

import styles from './favoriteButton.module.css';

interface FavoriteButtonProps {
  isFavorite: boolean;
  onToggle: () => void;
  productName: string;
}

export const FavoriteButton = ({
  isFavorite,
  onToggle,
  productName,
}: FavoriteButtonProps) => (
  <ImageActionButton
    onClick={onToggle}
    aria-label={`Favorite ${productName}`}
    aria-pressed={isFavorite}
  >
    {isFavorite ? (
      <HeartFilledIcon className={styles['heart']} color="primary" />
    ) : (
      <HeartIcon className={styles['heart']} />
    )}
  </ImageActionButton>
);
